import { useParams } from "react-router-dom";

const INFO = {
  reservation: ["Material Reservation / 物料预留", "ADA DI SOURCE (sheet Material Reservation, API WMS_web_createMaterialReservation)"],
  allocation: ["Allocation & Shortage / 分配与短缺", "ADA DI SOURCE (WMS_web_getAllocationDashboard)"],
  requirement: ["Requirement Planning / 物料需求计划", "ADA DI SOURCE (sheet WMS Material Requirement — kosong di data contoh)"],
  analytics: ["Analitik & Report / 数据分析与报表", "TERVERIFIKASI AKTIF (menu terlihat di produksi); isi detail belum diaudit"],
  masteredit: ["Koreksi Master Data / 主数据修正", "ADA DI SOURCE (Master Data Correction dengan approval)"],
};

export default function NotReplicated() {
  const { tab } = useParams();
  const [t, s] = INFO[tab] || [tab, "BELUM DIKETAHUI"];
  return (
    <div className="card" data-testid="not-replicated-page">
      <h3>{t}</h3>
      <div className="alert warning" data-testid="not-replicated-status">Status sumber: <b>{s}</b>. Modul ini <b>belum direplikasi</b> pada tahap 1 dan dijadwalkan pada tahap berikutnya. Tidak ada data contoh yang ditampilkan agar tidak menyesatkan.</div>
    </div>
  );
}
